// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"57568570","113":"4ad9e67a","253":"ff46d6af","287":"3cf23d80","413":"f37eb7ec","417":"5d4bc1b1","451":"51ad4403","492":"f4dee149","561":"05d8b35f","875":"490d921e","883":"4f522e23","946":"4304d5aa","964":"a716cde1"}[chunkId] + ".chunk.js";
};